import { toast } from "react-toastify"

export const errorToastify = (child) => {
    toast.error(child, {
        closeOnClick: false,
        position: "top-center",
        theme: "light",
        autoClose: 60000,
        pauseOnFocusLoss: false
    })
}

export const infoToastify = (child) => {
    toast.info(child, {
        closeOnClick: false,
        position: "top-center",
        theme: "colored",
        autoClose: 10000,
        pauseOnFocusLoss: false
    })
}

export const successToastify = (child) => {
    toast.success(child, {
        closeOnClick: false,
        position: "top-center",
        theme: "colored",
        autoClose: 10000,
        pauseOnFocusLoss: false
    })
}

export const removeAllToasts = () => {
    toast.dismiss()
}